(function () {

  const nvznAppData = JSON.parse(document.getElementById('nvzn-app-data').textContent);
  if (!nvznAppData) return console.error('[NVZN] nvznAppData not found');
  log('nvznAppData:', nvznAppData);

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }
    document.querySelectorAll('.nvzn3d-arbutton').forEach((button) => {
      button.addEventListener('click', function () {
        const action = button.dataset.action;
        const arImage = nvznAppData.product.arImage;

        const selectedVariant = getSelectedVariant();
        if (!selectedVariant) return console.error('[NVZN] Unable to determine selected variant');
        const dimensions = extractDimensions(selectedVariant.size);

        let options = {
          clientId: nvznAppData.app.clientID,
          width: dimensions.width,
          length: dimensions.length,
          units: dimensions.units,
        };
        if (action === 'viewer') {
          options.imageUrl = arImage;
          //options.allowScaling = true;
        } else if (action === 'sizer') {
          options.shape = selectedVariant.shape || 'rectangle';
        }
        log('AR Button Options:', options);
        Nvzn3D.displayFloorPreview(options);
      }
      );
    });
    // detect option changes
    window.addEventListener('change', function () {
      updateButtonVisibility();
    });
    // update buttons
    updateButtonVisibility();
  }

  function getSelectedVariant() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant') || nvznAppData.product.selectedOrFirstAvailableVariantID.toString();
    if (!variantId) return console.error('[NVZN] Unable to determine variant ID');
    const variant = nvznAppData.product.variants.find((v) => v.id.toString() === variantId);
    if (!variant) return console.error(`[NVZN] Variant with ID ${variantId} not found`);
    return variant || null;
  }

  function isFirstVariant(selectedVariant) {
    if (!selectedVariant || !nvznAppData.product.variants || nvznAppData.product.variants.length === 0) {
      return false;
    }
    const firstVariant = nvznAppData.product.variants[0];
    return firstVariant.id.toString() === selectedVariant.id.toString();
  }

  function updateButtonVisibility() {
    const arViewerBtnContainer = document.querySelector('.nvzn3d-arbutton-container--viewer');
    const arSizerBtnContainer = document.querySelector('.nvzn3d-arbutton-container--sizer');
    // hide all
    arViewerBtnContainer.classList.remove('show');
    arSizerBtnContainer.classList.remove('show');

    const selectedVariant = getSelectedVariant();
    const isFirstVariantSelected = isFirstVariant(selectedVariant);

    if (isFirstVariantSelected) {
      arViewerBtnContainer.classList.add('show');
    } else {
      arSizerBtnContainer.classList.add('show');
    }
  }

  function extractDimensions(sizeString) {
    let width, length, units;

    function normalizeFeetInches(part) {
      const normalizedPart = part.replace(/\s+/g, '').replace(/”/g, '"').replace(/′/g, "'").replace(/″/g, '"');
      const match = normalizedPart.match(/^(\d+(?:\.\d+)?)'(\d+(?:\.\d+)?)?"?$/);

      if (!match) {
        return normalizedPart;
      }

      const feet = parseFloat(match[1]);
      const inches = match[2];

      if (!inches) {
        const wholeFeet = Math.floor(feet);
        const remainingInches = Math.round((feet - wholeFeet) * 12);
        return remainingInches > 0 ? `${wholeFeet}'${remainingInches}"` : `${wholeFeet}'`;
      }

      return `${Math.floor(feet)}'${inches}"`;
    }

    if (sizeString.includes("'")) {
      units = 'ftin';
      [width, length] = sizeString.split(/\s*[xX]\s*/).map(normalizeFeetInches);
    } else {
      units = 'cm';
      [width, length] = sizeString.split(/\s*[xX]\s*/).map((part) => parseFloat(part.trim()));
    }

    return { width, length, units };
  }

  function log(...args) {
    if (nvznAppData.app && nvznAppData.app.logging) {
      console.log('[NVZN]', ...args);
    }
  }

  init();
})();